import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

const CITIES = ["Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret"];

export default function SearchBar() {
  const navigate = useNavigate();
  const [city, setCity] = useState("Nairobi");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [error, setError] = useState("");

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (from && to && new Date(to) < new Date(from)) {
      setError("Your return date needs to be after your pick-up date.");
      return;
    }
    setError("");
    const params = new URLSearchParams();
    if (city) params.set("city", city);
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    navigate(`/browse?${params.toString()}`);
  }

  const fieldClass =
    "w-full rounded-lg border border-background-200/70 bg-background-50/60 px-3 py-3 pl-10 text-sm text-foreground-950 placeholder:text-foreground-500 focus:border-primary-500 focus:outline-none";

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full rounded-2xl border border-background-200/80 bg-background-100/85 p-3 backdrop-blur-xl md:p-4"
    >
      <div className="grid grid-cols-1 gap-3 md:grid-cols-[1.1fr_1fr_1fr_auto]">
        <div className="relative">
          <i className="ri-map-pin-2-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500"></i>
          <select
            value={city}
            onChange={(event) => setCity(event.target.value)}
            className={`${fieldClass} cursor-pointer appearance-none`}
            aria-label="City"
          >
            {CITIES.map((option) => (
              <option key={option} value={option} className="bg-background-100">
                {option}
              </option>
            ))}
          </select>
          <i className="ri-arrow-down-s-line pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500"></i>
        </div>

        <div className="relative">
          <i className="ri-calendar-event-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500"></i>
          <input
            type="date"
            value={from}
            onChange={(event) => setFrom(event.target.value)}
            className={`${fieldClass} [color-scheme:dark]`}
            aria-label="Pick-up date"
          />
        </div>

        <div className="relative">
          <i className="ri-calendar-check-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500"></i>
          <input
            type="date"
            value={to}
            onChange={(event) => setTo(event.target.value)}
            className={`${fieldClass} [color-scheme:dark]`}
            aria-label="Return date"
          />
        </div>

        <button
          type="submit"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-search-line"></i> Search cars
        </button>
      </div>
      {error && (
        <p className="mt-2 flex items-center gap-1.5 text-xs text-secondary-300">
          <i className="ri-error-warning-line"></i> {error}
        </p>
      )}
    </form>
  );
}